/* eslint-disable complexity */
import {
  FETCH_COUNTRIES,
  FETCH_COUNTRIES_ERROR,
  RECEIVE_COUNTRIES,
  SET_INITIAL_COUNTRY,
} from "../../actions/PremierSelectorOptions";

const initialState = {
  countriesFetching: false,
  countriesFetched: false,
  payload: false,
};

const PremeierSelectorOptions = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COUNTRIES: {
      return Object.assign({}, state, {
        countriesFetching: true,
        error: undefined,
        payload: action.payload,
      });
    }
    case FETCH_COUNTRIES_ERROR: {
      return Object.assign({}, state, {
        error: action.payload,
      });
    }
    case RECEIVE_COUNTRIES: {
      return Object.assign({}, state, {
        countriesFetching: false,
        countriesFetched: true,
        countriesData: action.countriesData,
      });
    }
    case SET_INITIAL_COUNTRY: {
      return Object.assign({}, state, {
        selectedCountry: action.selectedCountry,
      });
    }
    default: {
      return state;
    }
  }
};

export default PremeierSelectorOptions;
